import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MUIToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import withStyles, { createStyles } from '../withStyles';
import ToggleButtonGroupButton from './ToggleButtonGroupButton';
import InputHelperText from '../InputHelperText';
import InputLabel from '../InputLabel';
export const ToggleButtonGroup = ({ children, value, onChange, label, disabled = false, helperText, classes, exclusive = false, }) => (_jsxs("div", Object.assign({ className: classes.root }, { children: [_jsx(InputLabel, Object.assign({ disabled: disabled }, { children: label })), _jsx(MUIToggleButtonGroup, Object.assign({ size: "small", value: value, exclusive: exclusive, onChange: (_, updatedValue) => {
                if (onChange) {
                    onChange(updatedValue);
                }
            } }, { children: children })), !!helperText && (_jsx(InputHelperText, Object.assign({ indent: true, disabled: disabled }, { children: helperText })))] })));
const styles = (theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        fontSize: theme.fontSizes.sm,
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(0.5),
    },
});
export default Object.assign(withStyles(styles)(ToggleButtonGroup), {
    Button: ToggleButtonGroupButton,
});
//# sourceMappingURL=ToggleButtonGroup.js.map